import { Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import styled from 'utils/styled';

export const Container = styled.div``;

export const StyledTitle = styled(Title)`
  margin-top: 80px;
  margin-bottom: 24px;
`;

export const SectionTitle = styled(Title)`
  margin-top: 40px;
`;

export const ButtonSpace = styled(Space)`
  width: 100%;
  justify-content: center;
  margin: 32px 0;
`;
